import * as Yup from 'yup';
import React, { useState, useEffect } from "react"
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './forgotPassword.css'
import Iconify from '../Iconify';
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { LoadingButton } from '@mui/lab';
import { Button, Stack, IconButton, InputAdornment, Box, TextField } from '@mui/material';
import { Link, useNavigate } from "react-router-dom"
import { changePassword, forgotPassword, generateOtp } from '../../api/password';
import { Watch } from '@mui/icons-material';
// -------------------------------------------------

const ForgotPassword = () => {
  const [showError, setShowError] = useState();
  const [showLoader, setShowLoader] = useState();
  const navigate = useNavigate()
  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
  });

  const defaultValues = {
    email: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = methods;
  const values = watch()
  const [showOtp, setShowOtp] = useState(false)
  const [otp, setOtp] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [password, setPassword] = useState('')
  const onSubmit = async (data) => {


    const response = await generateOtp(data)
    if (response.code === 201) {
      setShowOtp(true)
    }
  };
  const submitData = async () => {
    if (values.email === '' || values.email === undefined || values.email === null || otp === null || otp === undefined) {
      alert('Something went wrong ')
    } else {
      try {
        const resp = await forgotPassword({ email: values.email, otp: otp })
        console.log(resp)
        localStorage.setItem('token', resp.data)
        setShowPassword(true)
      } catch (error) {
        alert(error.message)
      }

    }
  }

  const submitPassword = async () => {
    if (password === null || password === undefined || password === '') {
      alert('Password filled is empty ')
    } else {
      try {
        const resp = await changePassword({ newPassword: password })
        if (resp.code === 202) {
          alert(resp.message)
          navigate('/login')
        }

      } catch (error) {
        alert(error.message)
      }

    }
  }

  useEffect(() => {
    localStorage.clear()
  }, [])

  return (
    <>
      <Header />
      <section className='py-5'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-9'>
              <Box
                sx={{
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 5px rgba(16, 16, 16, .09)',
                  p: 2,
                  borderRadius: '25px',
                }}
              >
                <div className='row'>
                  <div className='col-md-6'>
                    <img src='../images/forgot-pass.svg' />
                  </div>
                  <div className='col-md-6'>
                    <div className='accountSection'>
                      <img src='../images/logo.jpg' />
                      <h3>Forgot password?</h3>
                      <p className='pb-3'>Enter the email address associated with an account.</p>
                      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Stack sx={{ py: 1 }}>
                          <RHFTextField size="small" name="email" label="Enter email address" />
                        </Stack>
                        {showOtp && <Stack sx={{ py: 1 }}>
                          <TextField
                            value={otp}
                            type='number'
                            onChange={(e) => {
                              setOtp(e.target.value)
                            }}
                            size="small" name="otp" label="Enter OTP" />
                        </Stack>}
                        {showPassword && <Stack sx={{ py: 1 }}>
                          <TextField
                            value={password}
                            type='number'
                            onChange={(e) => {
                              setPassword(e.target.value)
                            }}
                            size="small" name="otp" label="Enter New Password" />
                        </Stack>}
                        {!showOtp ? <Stack sx={{ py: 1 }}>
                          <LoadingButton fullWidth size="large" type="submit" className='signBtn' loading={isSubmitting}>
                            Generate Otp
                          </LoadingButton>
                        </Stack> : showPassword ? <Stack sx={{ py: 1 }}>
                          <Button
                            onClick={submitPassword}
                            fullWidth size="large" className='signBtn' >
                            Change Password
                          </Button>
                        </Stack> : <Stack sx={{ py: 1 }}>
                          <Button
                            onClick={submitData}
                            fullWidth size="large" className='signBtn' >
                            Forgot Password
                          </Button>
                        </Stack>}

                      </FormProvider>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default ForgotPassword
